interface DividedPillProps {
  name: string;
  value: number;
  isDollarAmount?: boolean;
}

const DividedPill = ({ name, value, isDollarAmount }: DividedPillProps) => {
  const numberOfDigits = isDollarAmount ? 2 : 0;
  return (
    <>
      <div className="flex flex-col p-4 xl:p-8">
        <div className="text-[#FFFFF0] text-xl md:text-base font-general-sans-semibold uppercase">
          {name}
        </div>
        <div className="text-[#EEEDA8] py-1 md:py-0 text-5xl md:text-7xl font-general-sans-semibold">
          <span>
            {isDollarAmount ? '$' : ''}
            {value.toLocaleString(undefined, {
              minimumFractionDigits: numberOfDigits,
            })}
          </span>
        </div>
      </div>
      <span className="w-full flex from-[rgba(211,237,254,1)] to-[rgba(238,237,168,1)] bg-gradient-to-r xl:hidden h-[30px]" />
    </>
  );
};

export default DividedPill;
